import { Platform } from 'react-native';
import { getAttributionForSubmit } from '@/lib/attribution';
import { appendReturnToAppParam } from '@/lib/auth/web-onboarding-return-to-app';

const PROD_REGISTER_URL = 'https://controlapag.com.br/register';

/** Expo web local (mesma origem do front em dev). */
const DEV_REGISTER_URL =
  'https://39a3-2804-d84-223d-e200-d4fb-5540-cecf-55d9.ngrok-free.app/register';

const PROD_PROVIDER_REGISTER_URL = `${PROD_REGISTER_URL}?role=provider`;
const DEV_PROVIDER_REGISTER_URL = `${DEV_REGISTER_URL}?role=provider`;

const UTM_QUERY_MAP: Record<string, string> = {
  utmSource: 'utm_source',
  utmMedium: 'utm_medium',
  utmCampaign: 'utm_campaign',
  utmContent: 'utm_content',
  utmTerm: 'utm_term',
  fbclid: 'fbclid',
  fbc: 'fbc',
  fbp: 'fbp',
};

export function isNativePlatform(): boolean {
  return Platform.OS === 'ios' || Platform.OS === 'android';
}

/**
 * URL web para cadastro (App Store / Play — cadastro fora do app).
 */
export function getProviderRegisterWebUrl(options?: { role?: 'provider' | 'client' }): string {
  const fromEnv = process.env.EXPO_PUBLIC_PROVIDER_REGISTER_URL?.trim();
  const base = fromEnv || (__DEV__ ? DEV_PROVIDER_REGISTER_URL : PROD_PROVIDER_REGISTER_URL);
  const withAttribution = appendAttributionToUrl(base, getAttributionForSubmit(), options?.role);
  return isNativePlatform() ? appendReturnToAppParam(withAttribution) : withAttribution;
}

function appendAttributionToUrl(
  base: string,
  attribution: ReturnType<typeof getAttributionForSubmit>,
  roleOverride?: 'provider' | 'client',
): string {
  try {
    const url = new URL(base);
    for (const [key, param] of Object.entries(UTM_QUERY_MAP)) {
      const value = attribution[key as keyof typeof attribution];
      if (value && !url.searchParams.has(param)) {
        url.searchParams.set(param, value);
      }
    }
    if (roleOverride === 'client') {
      url.searchParams.set('role', 'CLIENT');
    } else if (roleOverride === 'provider' || !url.searchParams.has('role')) {
      url.searchParams.set('role', 'provider');
    }
    return url.toString();
  } catch {
    return base;
  }
}
